<template>
    <div>
        <el-col>
            <el-menu
            :unique-opened='true'
            :router="true"
            class="el-menu-vertical-demo"
            background-color="transparent"
            text-color="#444"
            :default-active="logUrl"
            :collapse="isCollapse"
            :collapse-transition = "false"
            >
                <common-menu :getMenu="getMenu" :isCollapse="isCollapse"></common-menu>
            </el-menu>
        </el-col>
    </div>
</template>
<script>
import CommonMenu from './menu'
import { mapState,mapActions } from "vuex";
export default {
    name:'sidelist',
    props:{
        isCollapse:Boolean,
    },
    data(){
        return{
            getMenu:[],
            currentMenu:'/home',
        }
    },
    components: {
        CommonMenu
    },
    computed:{
        logUrl(){
            return this.$store.state.logUrl;
        }
    },
    methods:{
        ...mapActions([  
            'saveMenu',"saveLogUrl"
        ]),
        //获取菜单
        findTreeDatas:function(){
            this.$api.post(this.API.api + 'home/onLoadSysMenu',{},res=>{
                this.getMenu = res.data; 
                this.saveMenu(this.getMenu);
            })
        },
    },
    mounted(){
        // console.log(this.logUrl)
    },
    created(){
        this.saveMenu(this.getMenu);
        this.findTreeDatas();
    },
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 220px;
    min-height: 400px;
  }
</style>




// WEBPACK FOOTER //
// src/views/components/SideList.vue